import { post, get } from '@axios';
import { showLoader, hideLoader } from 'actions/loader';
import { requests } from 'shared/requests';
import { login as loginSubmit } from 'actions/auth';
import { AUTH_LOGOUT } from 'actions/auth';
import { INITIATE_STORES } from 'actions/stores';
import { SHOW_ERROR_MODAL } from 'actions/errorModal';
import { INITIAL_SYNC_PRODUCTS } from 'actions/sync-products';

const UPDATE_USER_FIELD = 'UPDATE_USER_FIELD';
const SET_USER_EMAIL = 'SET_USER_EMAIL';
const SET_USER_PASSWORD = 'SET_USER_PASSWORD';
const USER_INITIATE = 'USER_INITIATE';
const SET_USER_CONFIRM_PASSWORD = 'SET_USER_CONFIRM_PASSWORD';
const TOGGLE_TERMS_AND_CONDITION = 'TOGGLE_TERMS_AND_CONDITION';

const getUserInformation = (emailid) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.userData,
        data: {
          user: emailid,
        },
      });
      dispatch(hideLoader());
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const confirmEmail = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const confirm = await post({
        url: requests.notifyNewUser,
        data: data,
      });
      dispatch(hideLoader());
      return confirm;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const declineBotUser = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const confirm = await post({
        url: requests.declineBotUser,
        data: data,
      });
      dispatch(hideLoader());
      return confirm;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const approveBotUser = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const confirm = await post({
        url: requests.approveBotUser,
        data: data,
      });
      dispatch(hideLoader());
      return confirm;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const updateUserInformation = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.updateUserInfo,
        data,
      });
      dispatch(hideLoader());

      await dispatch(
        loginSubmit({
          email: data?.email,
          password: data?.password,
        })
      );
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const deactivateUser = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.deactivateUser,
        data,
      });
      dispatch(hideLoader());
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const updatePassword = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.updatePassword,
        data,
      });
      dispatch(hideLoader());
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const forgotPassword = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.forgotPassword,
        data,
      });
      dispatch(hideLoader());
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const getAllSubmittedUsers = (data, token) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.getAllSubmittedUsers,
        data,
        token: `Bearer ${token}`,
      });
      dispatch(hideLoader());

      if (user?.tokenExpired) {
        dispatch({ type: INITIATE_STORES });
        dispatch({ type: AUTH_LOGOUT });
        dispatch({ type: INITIAL_SYNC_PRODUCTS });
      }

      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const getSearchedSubmittedUsers = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.getSearchedSubmittedUsers,
        data,
      });
      dispatch(hideLoader());
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const updateUserStatus = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await post({
        url: requests.updateUserStatus,
        data,
      });
      dispatch(hideLoader());
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const getAllSubmittedUsersCSV = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const user = await get({
        url: requests.getAllSubmittedUsersCSV,
      });
      dispatch(hideLoader());
      return user;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const checkAppVersion = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const version = await get({
        url: requests.checkAppVersion,
      });
      dispatch(hideLoader());
      return version;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const automationToggle = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const response = await post({
        url: requests.automationToggle,
        data,
      });
      dispatch(hideLoader());
      return response;
    } catch (error) {
      dispatch(hideLoader());
      return { error: true, message: error.message };
    }
  };
};

const deleteUnSyncedOrders = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const response = await post({
        url: requests.deleteUnSyncedOrders,
        data,
      });
      dispatch(hideLoader());
      return response;
    } catch (error) {
      dispatch(hideLoader());
      return { error: true, message: error.message };
    }
  };
};

export {
  SET_USER_EMAIL,
  SET_USER_PASSWORD,
  UPDATE_USER_FIELD,
  USER_INITIATE,
  SET_USER_CONFIRM_PASSWORD,
  TOGGLE_TERMS_AND_CONDITION,
  getUserInformation,
  confirmEmail,
  updateUserInformation,
  deactivateUser,
  updatePassword,
  getAllSubmittedUsers,
  getSearchedSubmittedUsers,
  updateUserStatus,
  declineBotUser,
  approveBotUser,
  forgotPassword,
  getAllSubmittedUsersCSV,
  checkAppVersion,
  automationToggle,
  deleteUnSyncedOrders,
};
